import React from 'react';

const StatusBadge = ({ status, size = 'md' }) => {
  const getStatusConfig = (status) => {
    const configs = {
      TRIAL: {
        label: 'Trial',
        color: 'bg-blue-100 text-blue-800 border-blue-200',
        icon: '🧪',
        description: 'Free trial period'
      },
      ACTIVE: {
        label: 'Active',
        color: 'bg-green-100 text-green-800 border-green-200',
        icon: '✅',
        description: 'Subscription is active'
      },
      PAST_DUE: {
        label: 'Past Due',
        color: 'bg-red-100 text-red-800 border-red-200',
        icon: '⚠️',
        description: 'Payment is overdue'
      },
      CANCELLED: {
        label: 'Cancelled',
        color: 'bg-gray-100 text-gray-800 border-gray-200',
        icon: '❌',
        description: 'Subscription cancelled'
      },
      PENDING: {
        label: 'Pending',
        color: 'bg-yellow-100 text-yellow-800 border-yellow-200',
        icon: '⏳',
        description: 'Payment being processed'
      },
      UNPAID: {
        label: 'Unpaid',
        color: 'bg-red-100 text-red-800 border-red-200',
        icon: '💳',
        description: 'Payment failed'
      },
      INCOMPLETE: {
        label: 'Incomplete',
        color: 'bg-orange-100 text-orange-800 border-orange-200',
        icon: '🔄',
        description: 'Setup incomplete'
      },
      INCOMPLETE_EXPIRED: {
        label: 'Expired',
        color: 'bg-red-100 text-red-800 border-red-200',
        icon: '⏰',
        description: 'Setup expired'
      }
    };

    return configs[status] || {
      label: status || 'Unknown',
      color: 'bg-gray-100 text-gray-800 border-gray-200',
      icon: '❓',
      description: 'Unknown status'
    };
  };

  const config = getStatusConfig(status);
  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  return (
    <div className="inline-flex items-center">
      <span
        className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full font-medium border ${config.color} ${sizeClasses[size]}`}
        title={config.description}
      >
        <span className="text-sm">{config.icon}</span>
        {config.label}
      </span>
    </div>
  );
};

export default StatusBadge;
